import { environment } from 'src/environments/environment';

export class Utility {
  constructor() {}

  static createBodyForPostRequest(data: any, isString?: boolean): any {
    const result: { body: string; requestContext?: any } = { body: '' };
    if (environment.name && environment.name.toUpperCase() === 'DEV') {
      let claims: Record<string, any> = {};
      try {
        const userStr = localStorage.getItem('user');
        if (userStr) {
          const user = JSON.parse(userStr);
          claims = {
            'custom:boBillingAccounts': Array.isArray(user.boBillingAccounts) ? user.boBillingAccounts.join(',') : '',
            'custom:loBillingAccounts': Array.isArray(user.loBillingAccounts) ? user.loBillingAccounts.join(',') : '',
            'custom:flBillingAccounts': Array.isArray(user.flBillingAccounts) ? user.flBillingAccounts.join(',') : '',
            'custom:operator': user.operator || '',
            'cognito:groups': Array.isArray(user.userGroups) ? user.userGroups.join(',') : '',
            'custom:leadOperatorId' : user.leadOperatorId || '',
            'custom:customerNames' : Array.isArray(user.customerNames) ? user.customerNames.join(',') : ''  
          };
        }
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
      }
      result.requestContext = { authorizer: { claims } };
      result.body = isString ? data : JSON.stringify(data);
    } else {
      return data;
    }
    return result;
  }

  static createBodyForPostResponse(data: any): any {
    if (environment.name && environment.name.toUpperCase() === 'DEV') {
      try {
        return JSON.parse(data.body);
      } catch (error) {
        console.error('Error parsing response body:', error);
        return data;
      }
    } else {
      return data;
    }
  }

  static downloadFile(url : string): void {
const link = document.createElement('a');
 link.href = url;

 document.body.appendChild(link);
 link.click();
 document.body.removeChild(link);
 }

 
static async  downloadFile1(url : string): Promise<void> {
  const response = await fetch(url);
  const blob = await response.blob();
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'download.csv'; // Force filename
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

}
